import clsx from 'clsx'
import classes from '../Card.module.scss'
import PropTypes from 'prop-types'

function sizeCalc(long){
    if (long < 3) {
        return "--xl";
    } else if (long < 25) {
        return "--l";
    } else if (long < 51) {
        return "--m";
    } else if (long < 125) {
        return "--s";
    } else {
        return "--xs";
    }
}

export function CardText({ text }) {
    const sizeClass = sizeCalc(text.length)
    return (
        <div className={clsx(classes.card__content, classes["card--text"])} >
            <div className={clsx(classes["card-text"],classes[sizeClass])}>
                {text}
            </div>
        </div>
    )
}

CardText.propTypes = {
    text: PropTypes.string.isRequired
}